module.exports = __webpack_public_path__ + "img/logo-monday.da519687.svg";